import React from 'react';
import { FreeConsultLink } from './FreeConsultLink';
import { SmartphoneIcon, CameraIcon, MessagesSquareIcon, ClipboardCheckIcon, EyeIcon, RepeatIcon, BrainIcon, HeartPulseIcon, PlayCircleIcon } from 'lucide-react';
export const MethodDetails = ({
  openModal
}) => {
  return <section className="mb-10" data-id="element-250">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-251">
        Hoe onze online coaching werkt
      </h2>
      <div className="space-y-8 mb-8" data-id="element-252">
        <div className="flex items-start" data-id="element-253">
          <div className="mr-4 flex-shrink-0" data-id="element-254">
            <SmartphoneIcon className="w-10 h-10 text-blue-500" data-id="element-255" />
          </div>
          <div data-id="element-256">
            <h3 className="font-bold text-lg mb-2" data-id="element-257">
              Waarom online effectiever is
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-258">
              <li data-id="element-259">
                <strong data-id="element-260">Flexibiliteit:</strong> Training past in jouw schema,
                niet andersom
              </li>
              <li data-id="element-261">
                <strong data-id="element-262">Zelfstandig succes:</strong> jij leert hoe je dit
                zelfstandig doet met je hond zodat je het straks zonder expert
                kan.
              </li>
              <li data-id="element-263">
                <strong data-id="element-264">Dagelijkse feedback:</strong> WhatsApp begeleiding zodat
                je advies krijgt op het juiste moment
              </li>
              <li data-id="element-265">
                <strong data-id="element-266">Kostenefficiënt:</strong> Geen dure thuisbezoeken, meer
                budget voor echte begeleiding
              </li>
            </ul>
          </div>
        </div>
        <div className="flex items-start" data-id="element-267">
          <div className="mr-4 flex-shrink-0" data-id="element-268">
            <CameraIcon className="w-10 h-10 text-blue-500" data-id="element-269" />
          </div>
          <div data-id="element-270">
            <h3 className="font-bold text-lg mb-2" data-id="element-271">
              De technologie die het verschil maakt
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-272">
              <li data-id="element-273">
                <strong data-id="element-274">Huisdiercamera:</strong> Krijg je van ons, geeft
                onmiddellijk inzicht in de echte emoties van je hond
              </li>
              <li data-id="element-275">
                <strong data-id="element-276">WhatsApp coaching:</strong> Deel video's, krijg direct
                feedback en antwoord op vragen
              </li>
              <li data-id="element-277">
                <strong data-id="element-278">Stap-voor-stap plan:</strong> Volledig gepersonaliseerd
                voor jouw situatie
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="w-full mb-8" data-id="element-279">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iYrAaC3dEfYN1jz63Hx9nF/freepik__the-style-is-candid-image-photography-with-natural__77412.png" alt="Vrouw bekijkt haar beagle via huisdiercamera op smartphone en laptop" className="w-full h-auto rounded-lg shadow-md" data-id="element-280" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-281">
          "Met onze huisdiercamera zie je precies hoe je hond zich voelt als je
          weg bent"
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-282">
        <div className="bg-gray-50 p-5 rounded-lg" data-id="element-283">
          <h3 className="font-bold text-lg mb-3 flex items-center" data-id="element-284">
            <EyeIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-285" />
            Jouw rol in het proces
          </h3>
          <ul className="list-disc pl-6 space-y-2" data-id="element-286">
            <li data-id="element-287">
              <strong data-id="element-288">Leren observeren:</strong> Herken signalen van stress
              versus ontspanning
            </li>
            <li data-id="element-289">
              <strong data-id="element-290">Consequent toepassen:</strong> Volg het plan voor de beste
              resultaten
            </li>
            <li data-id="element-291">
              <strong data-id="element-292">Communiceren:</strong> Deel je ervaringen voor optimale
              begeleiding
            </li>
            <li data-id="element-293">
              <strong data-id="element-294">Geduld en vertrouwen:</strong> Geef de methode de tijd om
              te werken
            </li>
          </ul>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg" data-id="element-295">
          <h3 className="font-bold text-lg mb-3 flex items-center" data-id="element-296">
            <BrainIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-297" />
            Onze rol
          </h3>
          <ul className="list-disc pl-6 space-y-2" data-id="element-298">
            <li data-id="element-299">
              <strong data-id="element-300">Expert diagnose:</strong> Jaren ervaring in gedragsanalyse
            </li>
            <li data-id="element-301">
              <strong data-id="element-302">Gepersonaliseerd plan:</strong> Elke hond is uniek
            </li>
            <li data-id="element-303">
              <strong data-id="element-304">Continue begeleiding:</strong> Dagelijkse feedback en
              aanpassingen
            </li>
            <li data-id="element-305">
              <strong data-id="element-306">Probleemoplossing:</strong> Als er obstakels komen, helpen
              we direct
            </li>
          </ul>
        </div>
      </div>
      <div className="bg-blue-50 p-6 rounded-lg mb-6 border border-blue-200" data-id="element-307">
        <h3 className="text-lg font-bold text-blue-800 mb-4 flex items-center" data-id="element-308">
          <MessagesSquareIcon className="w-5 h-5 mr-2" data-id="element-309" />
          Een typisch traject ziet er zo uit:
        </h3>
        <ol className="space-y-4 list-decimal pl-6" data-id="element-310">
          <li data-id="element-311">
            <strong data-id="element-312">Week 1: Diagnose & Basis</strong>
            <p className="text-sm text-gray-700 mt-1" data-id="element-313">
              We analyseren het gedrag van je hond via de camera en
              vragenlijsten. Je krijgt een gepersonaliseerd plan gericht op het
              onderliggende probleem.
            </p>
          </li>
          <li data-id="element-314">
            <strong data-id="element-315">Week 2-3: Fundament leggen</strong>
            <p className="text-sm text-gray-700 mt-1" data-id="element-316">
              We werken aan de basis: geluidsangst verminderen, verveling
              tegengaan, of FOMO behandelen - afhankelijk van de diagnose.
            </p>
          </li>
          <li data-id="element-317">
            <strong data-id="element-318">Week 4-5: Begin strategisch oefenen</strong>
            <p className="text-sm text-gray-700 mt-1" data-id="element-319">
              Nu de basis staat, beginnen we met alleen-blijf oefeningen die
              specifiek zijn afgestemd op jouw hond's behoeften. Meeste honden
              kunnen al snel 10 minuten alleen blijven.
            </p>
          </li>
          <li data-id="element-320">
            <strong data-id="element-321">Week 6-8: Uitbreiden</strong>
            <p className="text-sm text-gray-700 mt-1" data-id="element-322">
              We bouwen de tijd stapsgewijs uit. We sturen continu bij op het
              stressniveau van je hond. De meeste honden kunnen na 8 weken 30
              minuten alleen blijven. Baasje kan nu een snelle boodschap doen en
              de stappen bij het oefenen worden groter.
            </p>
          </li>
          <li data-id="element-323">
            <strong data-id="element-324">Week 9-12: Verder uitbreiden & Bestendigen</strong>
            <p className="text-sm text-gray-700 mt-1" data-id="element-325">
              We bouwen de tijd verder uit en werken aan verschillende
              scenario's. De meeste honden kunnen nu meer dan 60 minuten alleen
              blijven. Vanaf hier gaat het sneller en kan een hond vaak per keer
              oefenen 5 tot 15 minuten langer alleen blijven.
            </p>
          </li>
        </ol>
      </div>
      <div className="bg-gray-50 p-5 rounded-lg mb-6 flex items-center" data-id="element-326">
        <PlayCircleIcon className="w-10 h-10 text-blue-500 mr-4 flex-shrink-0" data-id="element-327" />
        <div data-id="element-328">
          <h3 className="font-bold mb-1" data-id="element-329">Wil je eerst meer weten?</h3>
          <p className="text-sm mb-2" data-id="element-330">
            Bekijk onze uitleg video "Hoe je verlatingsangst aanpakt" door
            Stressless Dogs. In 15 minuten leg ik precies uit waarom
            traditionele methoden falen en hoe onze aanpak anders is.
          </p>
          <a href="https://training.stresslessdogs.nl/va-video" className="mt-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200 text-sm" data-id="element-331">
            BEKIJK DE GRATIS UITLEG VIDEO
          </a>
        </div>
      </div>
      <div className="flex items-center justify-center space-x-4 mb-6" data-id="element-332">
        <div className="flex items-center" data-id="element-333">
          <ClipboardCheckIcon className="w-5 h-5 text-green-500 mr-1" data-id="element-334" />
          <span className="text-sm" data-id="element-335">Geen lange contracten</span>
        </div>
        <div className="flex items-center" data-id="element-336">
          <RepeatIcon className="w-5 h-5 text-green-500 mr-1" data-id="element-337" />
          <span className="text-sm" data-id="element-338">Maandelijks opzegbaar</span>
        </div>
        <div className="flex items-center" data-id="element-339">
          <HeartPulseIcon className="w-5 h-5 text-green-500 mr-1" data-id="element-340" />
          <span className="text-sm" data-id="element-341">Stressvrije aanpak</span>
        </div>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-342">
        <FreeConsultLink onClick={openModal} data-id="element-343">
          Wil je weten hoe onze methode voor jouw hond zou werken?
        </FreeConsultLink>{' '}
        Plan een gratis intake gesprek en ontdek wat er écht speelt.
      </p>
    </section>;
};